exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gris-couleur[data-v-d6a116ce]{background-color:#e0e0e0}.white-couleur[data-v-d6a116ce]{color:#fff}.v-card__title[data-v-d6a116ce]{line-height:1.5rem}.bold-text[data-v-d6a116ce],.v-card__title[data-v-d6a116ce]{font-size:1.2rem;font-weight:400;letter-spacing:normal}.titreEvent[data-v-d6a116ce]{text-decoration:none}.titreEvent[data-v-d6a116ce]:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d6a116ce","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/events/index-past.vue
// module id = bMv4
// module chunks = 1